const businessPageData = {
    header : {
        image : {
            name : "business.jpg",
            alt : "Business Strategy wallpaper",
        },
    },
    mainTitle : "Our Business Strategy with an ESG Focus",
    paragraphOne : "With the announcement of the Saudi Green Initiative (SGI) and the formal declaration of the Kingdom’s Nationally Determined Contributions (NDC) at COP26 in 2021, SAB deployed an ambitious strategy to support the ESG initiatives laid out in the NDCs and Vision 2030. ESG was consciously built into SAB’s overall corporate strategy, which guides its implementation at every level of the organisation.",
    borderLeftBox : {
        title : "Vision",
        subtitle : "We bring a world of financial opportunities to an ambitious Kingdom",
    },
    cardsOne : [
        {
            icon : {
                name : "mobile.svg",
                alt : "",
            },
            subtitle : "Offer a leading online and mobile digital banking experience",
        },
        {
            icon : {
                name : "star.svg",
                alt : "",
            },
            subtitle : "Best in class universal banking serving all customer groups in the Kingdom"
        },
        {
            icon : {
                name : "money.svg",
                alt : "",
            },
            subtitle : "Be the leading international bank in the Kingdom, accessing an unrivalled global network through HSBC",
        },
        {
            icon : {
                name : "earth.svg",
                alt : "",
            },
            subtitle : "Embed ESG at the heart of the organisation, making SAB the most attractive organisation for all stakeholders",
        },
    ],
    paragraphTwo : "In choosing to “embed ESG at the heart of our organisation”, SAB’s corporate strategy reflects the significance of ESG to all our stakeholders – how we interact with communities, value chains, shareholders, and our people. ",
    borderLeftTitle : "Our actions to outgrow the market ",
    cardsTwo : [
        {
            icon : {
                name : "woman.svg",
                alt : "",
            },
            title : "Build on our core strengths",
            list : [
                "Bank of choice for large corporates",
                "Reinforce leadership in trade and payments",
                "Maintain leadership in wealth",
                "Reinforce our position in cards",
            ],
        },
        {
            icon : {
                name : "hand.svg",
                alt : "",
            },
            title : "Maximise our participation in key growth areas",
            list : [
                "Fast growing mid-corporate business",
                "Digital MSME focus",
                "Mortgage expansion",
                "Growth in sustainable finance and investment assets, deposits, and revenue",
            ]
        },
        {
            icon : {
                name : "earth-hand.svg",
                alt : "",
            },
            title : "Transform the organisation",
            list : [
                "Lead in digital innovation and evolve the IT architecture",
                "Transforming HR and developing the right talent",
                "Revamp operating model through improved data management, automation, and digitisation",
                "Align the Bank with KSA’s Green Initiative, supporting a sustainable future for the Kingdom",
            ]
        }
    ],
    timeLine : {
        title : "Long-term planning",
        subtitle : "SAB’s ESG planning encompasses the short, medium and long-term – with an ESG roadmap paving the way to 2060.",
        headers : ["2022-25", "2025", "2025-30", "2030-40", "2040 & beyond-60", "2060 or earlier"],
        data : [
            <p><b>Build capability</b></p>,
            <p><b>Achieve sustainable financing</b> and investments of <b>SAR 34 billion</b></p>,
            <p><b>Integrate ESG</b> into our businesses and functions</p>,
            <p>Achieve <b>Net Zero</b> in our <b>operations</b></p>,
            <p><b>Lead, track, measure, monitor, reassess, and review ambitions</b></p>,
            <p>Achieve <b>Net Zero</b> in our <b>financed emissions</b></p>,
        ],
        paragraph : "Our near-term ambition is to build capability in terms of sustainable finance, climate risk frameworks, learning and development, industry knowledgeable bank, and partnerships to advance SAB on this journey.",
    }
};

export default businessPageData;